import { call, put, takeEvery } from "redux-saga/effects";

import {
  CHECK_LIST,
  CHECK_FILTER,
  CHECK_UPDATE,
  CONSIGNMENT_LIST,
  CONSIGNMENT_FILTER,
  CONSIGNMENT_UPDATE,
} from "store/payments/actionTypes";

import {
  checkListSuccess,
  checkUpdateSuccess,
  consignmenListSuccess,
  consignmentUpdateSuccess,
  paymentRequestFailed,
} from "store/payments/actions";

import {
  getCheckList,
  getCheckFilter,
  patchCheckUpdate,
  getConsignmentList,
  getConsignmentFilter,
  patchConsignmentUpdate,
} from "connection/backend";

function* checkListSaga() {
  console.log("Trayendo lista de cheques...");
  try {
    const response = yield call(getCheckList);
    if (response.status === 200) {
      yield put(checkListSuccess(response.data));
    } else {
      yield put(paymentRequestFailed(response.data));
    }
  } catch (error) {
    yield put(paymentRequestFailed(error.response.data));
  }
}

function* checkFilterSaga({ payload: { changeUrl } }) {
  try {
    const response = yield call(getCheckFilter, { changeUrl });
    if (response.status === 200) {
      yield put(checkListSuccess(response.data));
    } else {
      yield put(paymentRequestFailed(response.data));
    }
  } catch (error) {
    yield put(paymentRequestFailed(error.response.data));
  }
}

function* checkUpdateSaga({ payload: { id, data } }) {
  console.log("Actualizando estado del cheque...");
  try {
    const response = yield call(patchCheckUpdate, { id }, data);
    if (response.status === 201) {
      yield put(checkUpdateSuccess(response.data));
    } else {
      yield put(paymentRequestFailed(response.data));
    }
  } catch (error) {
    yield put(paymentRequestFailed(error.response.data));
  }
}

function* consignmentListSaga() {
  console.log("Trayendo lista de consignaciones...");
  try {
    const response = yield call(getConsignmentList);
    if (response.status === 200) {
      yield put(consignmenListSuccess(response.data));
    } else {
      yield put(paymentRequestFailed(response.data));
    }
  } catch (error) {
    yield put(paymentRequestFailed(error.response.data));
  }
}

function* consignmentFilterSaga({ payload: { changeUrl } }) {
  try {
    const response = yield call(getConsignmentFilter, { changeUrl });
    if (response.status === 200) {
      yield put(consignmenListSuccess(response.data));
    } else {
      yield put(paymentRequestFailed(response.data));
    }
  } catch (error) {
    yield put(paymentRequestFailed(error.response.data));
  }
}

function* consignmentUpdateSaga({ payload: { id, data } }) {
  console.log("Cancelando consignación...");
  try {
    const response = yield call(patchConsignmentUpdate, { id }, data);
    if (response.status === 201) {
      yield put(consignmentUpdateSuccess(response.data));
    } else {
      yield put(paymentRequestFailed(response.data));
    }
  } catch (error) {
    yield put(paymentRequestFailed(error.response.data));
  }
}

export default function* paymentSaga() {
  yield takeEvery(CHECK_LIST, checkListSaga);
  yield takeEvery(CHECK_FILTER, checkFilterSaga);
  yield takeEvery(CHECK_UPDATE, checkUpdateSaga);
  yield takeEvery(CONSIGNMENT_LIST, consignmentListSaga);
  yield takeEvery(CONSIGNMENT_FILTER, consignmentFilterSaga);
  yield takeEvery(CONSIGNMENT_UPDATE, consignmentUpdateSaga);
}
